// extracted by mini-css-extract-plugin
module.exports = {"promoPartOne":"az__wc","promoPartTwo":"az_axc","promoCode":"az_bxc"};